module.exports = __webpack_public_path__ + "img/defaultAvatar_Male.4a5beff8.jpg";